// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";
import { redirect } from "react-router";
import { store } from "../../../store/store";

import { getAccessToken } from "../../../../web-utils/src/utils/storageUtils";
import { fetchUser, fetchUserInvites } from "../../../store/user/userActions";

import { fetchUserStudios } from "../../../store/studio/studioActions";
import { fetchUnrealVersion } from "../../../store/scenes/scenesActions";
import { clearAllErrors } from "../../../store/globalActions";

import axiosInstance from "../../../services/axiosInstance";

import { Loader } from "../../../../web-utils/src/UI/Component/React/V1/Loader/Loader";

export async function RootLoader() {
  const accessToken = getAccessToken();
  // user unauthenticated redirect to login
  if (!accessToken) {
    return redirect("/login");
  }
  // Set the Authorization header for axios
  axiosInstance.defaults.headers.common.Authorization = accessToken;

  // clear all errors
  store.dispatch(clearAllErrors());

  const state = store.getState();
  const userId = state.user?.user?.user_id;
  // get user data if not already fetched
  if (!userId) {
    await Promise.all([
      store.dispatch(fetchUser()),
      store.dispatch(fetchUserStudios()),
      store.dispatch(fetchUserInvites()),
      store.dispatch(fetchUnrealVersion()),
    ]);
  }

  return null;
}

RootLoader.hydrate = true;

export function HydrateFallback() {
  return <Loader />;
}
